import {
  GENERAL_PURCHASE_REGISTER_REPORT_REQUEST,
  GENERAL_PURCHASE_REGISTER_REPORT_SUCCESS,
  GENERAL_PURCHASE_REGISTER_REPORT_FAILURE
} from "../types/general-purchase-report-types";

const initialState = {
  generalPurchaseReports: {},
  loading: false,
  error: null,
};

const generalPurchaseReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_PURCHASE_REGISTER_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GENERAL_PURCHASE_REGISTER_REPORT_SUCCESS: {
      return {
        ...state,
        generalPurchaseRegisterReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GENERAL_PURCHASE_REGISTER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default generalPurchaseReportReducer;
